import React from "react";
import { Header, TopBar } from "../components/Header";
import { Footer } from "../components/Footer";


export function NotFoundPage() 
{   

    return(

        <div className="container-fluid">
           {/* _____________________SECTION HEADER EQUIPMENT ___________________ */} 
                
           <div className='row'> <TopBar /> </div>
           <div className='row sticky-top'> <Header /> </div>

          <div className="row justify-content-center align-items-center" style={{minHeight: '80vh', backgroundColor: '#f5f5f5'}}>
            <div className="col-lg-10">

              <div className="d-flex flex-column justify-content-center align-items-center g-4 px-4 py-5 bg-white border rounded-2">
                <div className="d-flex align-items-center">
                  <img src='../favicon.png' alt='logo-ortega' style={{ maxHeight: '70px' }}/>
                  <span className="display-2 fw-bold mb-1 text-green"> RTEGA </span>
                </div>
                <span className="display-1 text-green"> PAGE 404 </span>
              </div>
            </div>
          </div>

          {/* _____________________SECTION FOOTER EQUIPMENT ___________________ */} 
                    
          <div className='row'>
            <Footer />
          </div>

        </div>
    );
}